import React from 'react'

function Rodzice() {
  return (
    <div>Rodzice</div>
  )
}

export default Rodzice